import { apiRequest } from '@/lib/api/client'
import type {
  MetaConversionsDashboardPayload,
  MetaConversionsEventDetailPayload,
  MetaConversionsEventsResponse,
  MetaConversionsEventStatus,
} from '@/types/meta-conversions'

export interface MetaConversionsDateFilters {
  dateFrom?: string | null
  dateTo?: string | null
}

export interface MetaConversionsEventsFilters extends MetaConversionsDateFilters {
  page?: number
  perPage?: number
  status?: MetaConversionsEventStatus | ''
  q?: string | null
}

function buildQuery(
  params: Record<string, string | number | null | undefined>
): string {
  const search = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    search.set(key, String(value))
  })

  const query = search.toString()
  return query ? `?${query}` : ''
}

export async function fetchMetaConversionsDashboard(
  campaignId: number,
  filters: MetaConversionsDateFilters = {},
  token?: string | null
): Promise<MetaConversionsDashboardPayload> {
  const query = buildQuery({
    date_from: filters.dateFrom ?? undefined,
    date_to: filters.dateTo ?? undefined,
  })

  return apiRequest<MetaConversionsDashboardPayload>(
    `/api/campaigns/${campaignId}/meta-conversions/dashboard${query}`,
    {
      method: 'GET',
      requireAuth: true,
      token: token ?? undefined,
    }
  )
}

export async function fetchMetaConversionsEvents(
  campaignId: number,
  filters: MetaConversionsEventsFilters = {},
  token?: string | null
): Promise<MetaConversionsEventsResponse> {
  const query = buildQuery({
    page: filters.page ?? 1,
    per_page: filters.perPage ?? 20,
    date_from: filters.dateFrom ?? undefined,
    date_to: filters.dateTo ?? undefined,
    status: filters.status || undefined,
    q: filters.q?.trim() ? filters.q.trim() : undefined,
  })

  return apiRequest<MetaConversionsEventsResponse>(
    `/api/campaigns/${campaignId}/meta-conversions/events${query}`,
    {
      method: 'GET',
      requireAuth: true,
      token: token ?? undefined,
    }
  )
}

export async function fetchMetaConversionsEventDetail(
  campaignId: number,
  eventId: number,
  token?: string | null
): Promise<MetaConversionsEventDetailPayload> {
  return apiRequest<MetaConversionsEventDetailPayload>(
    `/api/campaigns/${campaignId}/meta-conversions/events/${eventId}`,
    {
      method: 'GET',
      requireAuth: true,
      token: token ?? undefined,
    }
  )
}
